import { IComboBox, IComboBoxOption } from "@fluentui/react";
import React, { useCallback, useRef, useState } from "react";

export const useComboGuardias = () => {
  const comboBoxRefGuardias = useRef<IComboBox>(null!);
  const _openOptionsComboGuardia = useCallback(() => {
    comboBoxRefGuardias.current?.focus(true);
  }, []);

  const onClickOpenGuardias = () => {
    _openOptionsComboGuardia();
  };

  const [dataComboGuardia, setDataComboGuardia] = useState<IComboBoxOption[]>([
    { key: "A", text: "A" },
    { key: "B", text: "B" },
    { key: "C", text: "C" },
    { key: "D", text: "D" },
  ]);

  return { dataComboGuardia, comboBoxRefGuardias, onClickOpenGuardias };
};
